import React from 'react'

const ScrollToTop = ({ show, onClick }) => {
  if (!show) return null

  return (
    <button
      className="scroll-to-top"
      onClick={onClick}
      aria-label="Scroll to top"
      type="button"
    />
  )
}

export default ScrollToTop
